export default {
  unitLabel: 'واحد',
  numeratorLabel: 'صورت کسر',
  numeratorUnitLable: 'واحد صورت کسر',
  denominatorUnitLabel: 'واحد مخرج کسر',
  denominatorLabel: 'مخرج کسر ',
  unitPlaceholder: 'پاسخ نهایی این سؤال چه واحدی دارد؟',
  numeratorPlaceholder:
    'سؤالی که مشخص می‌کند چه مقداری باید در صورت کسر قرار بگیرد.',
  denominatorPlaceholder:
    'سؤالی که مشخص می‌کند چه مقداری باید در مخرج کسر قرار بگیرد.(در صورتی که نیاز مخرج نیست، این بخش را خالی بگذارید)',
};
